import React, { useState } from "react";
import { withRouter, Link } from "react-router-dom";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import CipHeader from "../Components/CipHeader";
import cogoToast from "cogo-toast";
import censusService from "../services/eom-census-service";
import { Modal } from "react-responsive-modal";

import { kaReducer, Table } from "ka-table";
import { search, loadData, updateData } from "ka-table/actionCreators";
import { ActionType, SortingMode, PagingPosition } from "ka-table/enums";
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
import Loader from "react-loader-spinner";
const tablePropsInit = {
  columns: [
    { key: "payor", title: "Payor" },
    { key: "group", title: "Group" },
    { key: "unique", title: "Charge code" },
    { key: "census", title: "Census" },
    { key: "Actions", title: "Actions" },
  ],
  singleAction: loadData(),
  sortingMode: SortingMode.Single,
  rowKeyField: "id",
  search: ({ searchText, rowData, column }) => {
    if (column.key === "passed") {
      return (
        (searchText === "false" && !rowData.passed) ||
        (searchText === "true" && rowData.passed)
      );
    }
  },
  paging: {
    enabled: true,
    pageIndex: 0,
    pageSize: 10,
    position: PagingPosition.Bottom,
  },
};

const Census = ({ history }) => {
  const [loading, setLoading] = useState(false);
  const deleteCensus = async (id) => {
    try {
      await censusService.deleteData(id);
      let resp = await censusService.getCensusData();
      dispatch(updateData(resp));
    } catch (e) {
      const { hide } = cogoToast.error(
        "Error deleting census. Please try after sometime.",
        {
          hideAfter: 15,
          onClick: () => {
            hide();
          },
        }
      );
    }
  };

  const CustomCell = ({ rowData }) => {
    return (
      <div className="action_btns">
        <span className="inline-block mr-3 cursor-pointer">
          <Link to={`edit-census/${rowData.id}`}>
            <img src="/img/edit_icon.svg" className="mt-1 w-4 h-4" alt="logo" />
          </Link>
        </span>
        <span className="inline-block mx-4 cursor-pointer">
          <img
            src="./img/delete.svg"
            className="m-auto w-4 h-4"
            alt="delete"
            title="Delete"
            onClick={() => {
              setSelectedId(rowData?.id);
              setDeleteOpen(true);
            }}
          />
        </span>
      </div>
    );
  };

  const [selectedId, setSelectedId] = useState("");
  const [deleteOpen, setDeleteOpen] = useState(false);
  const onDeleteCloseModal = () => {
    setDeleteOpen(false);
    setSelectedId("");
  };

  const [tableProps, changeTableProps] = useState(tablePropsInit);
  const dispatch = async (action) => {
    changeTableProps((prevState) => kaReducer(prevState, action));
    if (action.type === ActionType.LoadData) {
      setLoading(true);
      let resp = await censusService.getCensusData();
      resp.sort(
        (d1, d2) =>
          new Date(d2.updatedAt).getTime() - new Date(d1.updatedAt).getTime()
      );
      setLoading(false);
      dispatch(updateData(resp));
    }
  };
  const [open, setOpen] = useState(false);
  const onCloseModal = () => {
    setOpen(false);
  };
  const [fileContent, setFileContent] = useState({});
  const handleDownload = async (event) => {
    try {
      const { hide } = cogoToast.info(
        "Downloading is in progress. Please wait for sometime.",
        {
          hideAfter: 15,
          onClick: () => {
            hide();
          },
        }
      );
      await censusService.downloadDocument();
    } catch (e) {
      const { hide } = cogoToast.error(
        "Error downloading document. Please try after sometime.",
        {
          hideAfter: 15,
          onClick: () => {
            hide();
          },
        }
      );
      setLoading(false);
    }
  };
  const handleUpload = async (event) => {
    try {
      let formDataUrl = new FormData();
      formDataUrl.append("excel", fileContent);
      formDataUrl.append("enctype", "multipart/form-data");
      await censusService.uploadDocument(formDataUrl);
      window.location.reload();
    } catch (e) {
      const { hide } = cogoToast.error(
        "Error uploading document. Please try after sometime.",
        {
          hideAfter: 15,
          onClick: () => {
            hide();
          },
        }
      );
      setLoading(false);
    }
  };

  return (
    <>
      <CipHeader />
      <div
        className={`inline-block customtop absolute z-50 ${
          loading ? "show" : "hidden"
        }`}
      >
        <Loader
          type="Oval"
          color="#00BFFF"
          height={50}
          width={50}
          timeout={300000} //3 secs
        />
      </div>
      <Modal open={deleteOpen} onClose={onDeleteCloseModal} center>
        <div className="pt-10 px-8 pb-4 ">
          <h3
            className="text-lg leading-6 font-medium text-gray-900 text-center"
            id="modal-headline"
          >
            Are you sure you want to delete?
          </h3>
          <div className="flex justify-center">
            <button
              onClick={() => {
                deleteCensus(selectedId);
                setDeleteOpen(false);
              }}
              type="button"
              className=" mr-4 rounded font-medium h-10 text-white w-auto px-6 bg-secondary bg-login_btn mb-3 mt-4 focus:outline-none"
            >
              Yes
            </button>

            <button
              onClick={() => {
                setDeleteOpen(false);
              }}
              type="button"
              className=" rounded font-medium h-10 text-white w-auto px-4 bg-grey bg-login_btn mb-3 mt-4 focus:outline-none"
            >
              Cancel
            </button>
          </div>
          {/*
           */}
        </div>
      </Modal>
      <div className="bg-white w-5/6 mx-auto mt-6 mb-4 rounded shadow-md">
        <div className="tableHeader flex clearboth shadow-md py-8 pl-3">
          <div className="w-1/3 text-darkclr font-semibold leading-10 ">
            <span className="text-xl">CENSUS</span>
          </div>
          <div className="w-full sm:w-2/3 text-right">
            <span className="mr-3">
              <button
                type="submit"
                className="rounded font-medium h-10 text-white bg-login_btn mb-2 py-2 px-7 focus:outline-none text-sm"
                aria-label="IMPORT"
                onClick={() => setOpen(true)}
              >
                UPLOAD
              </button>
            </span>
            <span className="mr-3">
              <button
                type="submit"
                className="rounded font-medium h-10 text-white bg-login_btn mb-2 py-2 px-7 focus:outline-none text-sm"
                aria-label="IMPORT"
                onClick={() => handleDownload()}
              >
                DOWNLOAD
              </button>
            </span>
            <span className="relative">
              <input
                type="search"
                defaultValue={tableProps.searchText}
                onChange={(event) => {
                  dispatch(search(event.currentTarget.value));
                }}
                placeholder=" Search"
                className="border rounded w-5/12 mb-2 h-10 mr-3 focus:outline-none focus:none pl-1 font-light align-bottom"
              />
              <img
                src="/img/search-2.svg"
                alt=""
                className="absolute w-4 h-4 mb-2 right-5 top-1 bottom-3"
              ></img>
            </span>
            <span className="mr-3">
              <Link
                to="/create-census"
                className=" bg-header_bg rounded mb-2 py-2 px-7 cursor-pointer text-xs font-bold text-white h-10 inline-block shadow-md leading-6"
              >
                ADD
              </Link>
            </span>
            <span className="mr-3">
              <Link
                to="/eomFiles"
                className=" bg-header_bg rounded mb-2 py-2 px-7 cursor-pointer text-xs font-bold text-white h-10 inline-block shadow-md leading-6"
              >
                GO TO EOM FILES
              </Link>
            </span>
          </div>
        </div>
        <Modal open={open} onClose={onCloseModal} center>
          <div className=" px-4 pb-4 ">
            <h3
              className="text-lg leading-6 font-medium text-gray-900 text-labelclr font-semibold py-4 tracking-wider"
              id="modal-headline"
            >
              Upload Document
            </h3>
            <div className="flex justify-center w-full mt-4">
              <input
                id="upload"
                name="upload"
                type="file"
                onChange={(e) => {
                  setFileContent(e.target.files[0]);
                }}
                className="focus:outline-none focus:none h-10 rounded-md pl-3 text-sm font-normal "
              />
            </div>
            <div className="flex justify-center">
              <button
                onClick={() => {
                  handleUpload();
                }}
                type="button"
                disabled={
                  Object.getPrototypeOf(fileContent) === Object.prototype
                }
                className="mr-4 rounded font-medium h-10 text-white w-auto px-4 bg-secondary bg-login_btn mb-3 mt-4 focus:outline-none"
              >
                Upload
              </button>
              <button
                onClick={() => setOpen(false)}
                type="button"
                className="mr-2 rounded font-medium h-10 text-white w-auto px-6 bg-grey bg-login_btn mb-3 mt-4 focus:outline-none"
              >
                Cancel
              </button>
            </div>
            {/*
             */}
          </div>
        </Modal>
        <div className="p-2 text-xs usersList gridList overflow-x-auto">
          <Table
            {...tableProps}
            childComponents={{
              cellText: {
                content: (props) => {
                  // eslint-disable-next-line default-case
                  switch (props.column.key) {
                    case "Actions":
                      return <CustomCell {...props} />;
                  }
                },
              },
            }}
            dispatch={dispatch}
          />
        </div>
      </div>
    </>
  );
};

export default withRouter(
  connect(
    () => ({}),
    (dispatch) => {
      return bindActionCreators({}, dispatch);
    }
  )(Census)
);
